import { Component, Input } from '@angular/core';
import { IResponsible } from '@shared/interfaces';

@Component({
    selector: 'app-organisation-item',
    templateUrl: './organisation-item.component.html',
    styleUrls: ['./organisation-item.component.scss'],
    standalone: false
})
export class OrganisationItemComponent {
    @Input() item: IResponsible;
    @Input() active: boolean;

    get responsible(): string {
        return this.item.responsible.filter(e => e.fullAccess)[0].fullName;
    }
}
